import { render, staticRenderFns } from "./MultiDropdownList.vue?vue&type=template&id=5a00db52&"
import script from "./MultiDropdownList.vue?vue&type=script&lang=ts&"
export * from "./MultiDropdownList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports